import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, SaveIcon, CheckIcon } from 'lucide-react';
export function QuoteStepNavigation({
  currentStep,
  totalSteps,
  onNext,
  onBack,
  onSave,
  isFinalStep = false
}) {
  return <div className="mt-8 pt-6 border-t border-blue-800/30 flex justify-between" data-id="element-4828">
      <button onClick={onBack} className="flex items-center px-4 py-2.5 rounded-lg bg-slate-700/50 text-blue-300 hover:bg-slate-700 hover:text-white transition-colors" disabled={currentStep === 0} data-id="element-4829">
        <ArrowLeftIcon size={18} className="mr-2" data-id="element-4830" />
        Back
      </button>
      <div className="flex gap-3" data-id="element-4831">
        <button onClick={onSave} className="flex items-center px-4 py-2.5 rounded-lg bg-blue-600/20 text-blue-300 hover:bg-blue-600/40 hover:text-white transition-colors" data-id="element-4832">
          <SaveIcon size={18} className="mr-2" data-id="element-4833" />
          Save Draft
        </button>
        <button onClick={onNext} className="flex items-center px-5 py-2.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors" data-id="element-4834">
          {isFinalStep ? <>
              <CheckIcon size={18} className="mr-2" data-id="element-4835" />
              Submit Quote
            </> : <>
              Next
              <ArrowRightIcon size={18} className="ml-2" data-id="element-4836" />
            </>}
        </button>
      </div>
    </div>;
}